import styled from 'styled-components';

const SectionNotFound = styled.section``;

export default SectionNotFound;
